import { render, staticRenderFns } from "./OrganizationalStructureMenu.vue?vue&type=template&id=23688198&scoped=true&"
import script from "./OrganizationalStructureMenu.vue?vue&type=script&lang=js&"
export * from "./OrganizationalStructureMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23688198",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23688198')) {
      api.createRecord('23688198', component.options)
    } else {
      api.reload('23688198', component.options)
    }
    module.hot.accept("./OrganizationalStructureMenu.vue?vue&type=template&id=23688198&scoped=true&", function () {
      api.rerender('23688198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/OrganizationalStructureMenu.vue"
export default component.exports